import "./TermsOfService.module.css";
import Header from "@/reusable_sections/Header";
import LocalAreaContent from "./sections/LocalAreaContent";
import ContactSupport from "./sections/ContactSupport";
import PricingPaymentRefundPolicy from "./sections/PricingPaymentRefundPolicy";
import LiabilityAndJurisdiction from "./sections/LiabilityAndJurisdiction";
import Footer from "@/reusable_sections/Footer";
export default function TermsOfServicePage() {
  return <div>
      <Header />
      <LocalAreaContent />
      <ContactSupport />
      <PricingPaymentRefundPolicy />
      <LiabilityAndJurisdiction />
      <Footer />
    </div>;
}